<template>
  <div>
    <p class="mb-2 mt-3">
      Add your children's information if you are ordering this yearbook for
      them.
    </p>
    <ul v-if="kids && kids.length > 0" style="margin: 15px 15px 15px 35px;">
      <li v-for="kid in kids" :key="kid.id">
        {{ kid.first_name }} {{ kid.last_name }}
        <el-tooltip
          class="item"
          effect="dark"
          content="Remove kid from order"
          placement="left"
        >
          <div style="float:right" @click="onClickRemoveKidButton(kid.id)">
            <el-icon
              name="remove-outline"
              style="color:red; cursor: pointer"
            ></el-icon>
          </div>
        </el-tooltip>
      </li>
    </ul>
    <div>
      <div>
        <el-button
          icon="el-icon-user"
          class="mt-2"
          @click="onClickAddChildrenButton"
          >Add New Kid</el-button
        >
      </div>
      <div>
        <el-button
          icon="el-icon-user"
          class="mt-2"
          @click="onClickAddFromMyKidsButton"
          :disabled="countKidsOkToAddToOrder === 0 || getKidsInfo.length === 0"
          >Choose Existing Kid ({{ countKidsOkToAddToOrder }})</el-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  name: "MyKidsWidget",
  data() {
    return {};
  },
  props: {
    kids: {
      type: Array
    },
    orderId: {
      type: String
    }
  },
  computed: {
    ...mapGetters(["getKidsInfo", "getStorefrontBookId"]),
    countKidsOkToAddToOrder() {
      // show a counter of kids available to add to the order
      let kidsForBook = this.getKidsInfo.filter(
        kid => kid.book_id === this.getStorefrontBookId
      );
      const countKidsInCurrentOrder = this.kids ? this.kids.length : 0;
      let count = kidsForBook.length - countKidsInCurrentOrder;
      if (count < 0) count = 0;
      return count;
    }
  },
  methods: {
    ...mapActions([
      "uiShowAddChildrenToOrderDialog",
      "getKids",
      "removeKidFromOrder"
    ]),
    onClickAddChildrenButton() {
      this.uiShowAddChildrenToOrderDialog();
    },
    onClickAddFromMyKidsButton() {
      this.uiShowAddChildrenToOrderDialog("existing");
    },
    async onClickRemoveKidButton(inKidId) {
      try {
        await this.removeKidFromOrder({
          orderId: this.orderId,
          kidId: inKidId
        });
      } catch (err) {
        this.$message({
          message: "Failed to remove kid from order. Please try again",
          type: "error"
        });
      }
    }
  },
  async mounted() {
    try {
      await this.getKids();
    } catch (err) {
      console.log(err);
    }
  }
};
</script>

<style scoped></style>
